// Estilos globais para ApexCharts, usando tokens CSS. O backdrop blur do tooltip
// usa filter backdrop-blur em dark mode e sombra em light mode (BackdropBlur do
// MUI). A cor do texto vem de --gps-text, border e sombra vem de tokens.

export default function ChartStyle() {
  return (
    <style>{`
      .apexcharts-canvas {
        /* Tooltip */
      }
      .apexcharts-canvas .apexcharts-xaxistooltip {
        border: 0;
        color: var(--gps-text);
        box-shadow: 0 1px 2px rgb(16 24 40 / 0.05), 0 8px 24px -14px rgb(16 24 40 / 0.18);
        border-radius: 18px;
        backdrop-filter: blur(6px);
        background: rgba(255, 255, 255, 0.8);
      }
      .apexcharts-canvas .apexcharts-xaxistooltip:before {
        border-bottom-color: transparent;
      }
      .apexcharts-canvas .apexcharts-xaxistooltip:after {
        border-bottom-color: rgba(246, 247, 249, 0.8);
      }
      [data-theme='dark'] .apexcharts-canvas .apexcharts-xaxistooltip {
        background: rgba(19, 22, 26, 0.8);
      }
      [data-theme='dark'] .apexcharts-canvas .apexcharts-xaxistooltip:after {
        border-bottom-color: rgba(19, 22, 26, 0.8);
      }
      .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light {
        border: 0;
        box-shadow: 0 1px 2px rgb(16 24 40 / 0.05), 0 8px 24px -14px rgb(16 24 40 / 0.18);
        border-radius: 18px;
        backdrop-filter: blur(6px);
        background: rgba(255, 255, 255, 0.8);
      }
      .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
        border: 0;
        text-align: center;
        font-weight: 700;
        background-color: rgba(107, 114, 128, 0.1);
        color: var(--gps-muted);
      }
      [data-theme='dark'] .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
        background-color: rgba(152, 161, 172, 0.1);
        color: var(--gps-text);
      }
      /* Legend */
      .apexcharts-canvas .apexcharts-legend {
        padding: 0;
      }
      .apexcharts-canvas .apexcharts-legend-series {
        display: flex !important;
        align-items: center;
      }
      .apexcharts-canvas .apexcharts-legend-marker {
        margin-right: 8px;
      }
      .apexcharts-canvas .apexcharts-legend-text {
        line-height: 18px;
        text-transform: capitalize;
      }
    `}</style>
  );
}
